import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DatePipe, TitleCasePipe } from "@angular/common";
import {
  PoChartOptions,
  PoChartSerie,
  PoChartType,
} from "@po-ui/ng-components";
import { DependencyTrackVulnerabilityMetrics } from "../../interfaces/dependency-track-vulnerability-metrics";

@Component({
  selector: "app-dependency-track-vulnerabilities-charts",
  templateUrl: "./dependency-track-vulnerabilities-charts.component.html",
  styleUrls: ["./dependency-track-vulnerabilities-charts.component.css"],
})
export class DependencyTrackVulnerabilitiesChartsComponent
  implements OnChanges
{
  @Input() items: DependencyTrackVulnerabilityMetrics;

  bySeverityOptions: PoChartOptions = {
    axis: {
      minRange: 0,
      gridLines: 5,
    },
  };
  categories: Array<string> = [];
  bySeveritySeries: Array<PoChartSerie> = [];
  bySeverityType: PoChartType = PoChartType.Line;
  totalOptions: PoChartOptions = {
    axis: {
      minRange: 0,
      gridLines: 5,
    },
  };
  totalSeries: Array<PoChartSerie> = [];
  totalType: PoChartType = PoChartType.Column;
  constructor(
    private datePipe: DatePipe,
    private titleCasePipe: TitleCasePipe
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes["items"]) {
      this.setCategories(this.items);
      this.setBySeverity(this.items);
      this.setTotal(this.items);
    }
  }

  private setBySeverity(items: DependencyTrackVulnerabilityMetrics): void {
    if (!items) return;

    this.bySeveritySeries = [
      {
        label: "Crítica(s)",
        data: items.series.critical,
        color: "color-07",
      },
      {
        label: "Alta(s)",
        data: items.series.high,
        color: "color-08",
      },
      {
        label: "Média(s)",
        data: items.series.medium,
        color: "color-09",
      },
      {
        label: "Baixa(s)",
        data: items.series.low,
        color: "color-10",
      },
      {
        label: "Indefinida(s)",
        data: items.series.unassigned,
        color: "color-02",
      },
    ];
  }

  private setTotal(items: DependencyTrackVulnerabilityMetrics): void {
    if (!items) return;

    this.totalSeries = [
      {
        data: items.series.total,
        label: "Vulnerabilidade(s)",
      },
    ];
  }

  private setCategories(items: DependencyTrackVulnerabilityMetrics) {
    if (!items) return;

    this.categories = items.categories.map(
      (date) =>
        this.titleCasePipe.transform(
          this.datePipe.transform(
            date.replace(/^(\d{4}-\d{2})$/, "$1-01"),
            "MMMM"
          ) || ""
        ) || ""
    );
  }
}
